import { combineReducers, configureStore } from "@reduxjs/toolkit"
import { setupListeners } from "@reduxjs/toolkit/query"
import { accountsApi } from "./accountSlice"
import appPanelReducer from "./appPanelSlice"
import broadcastReducer from "./broadcastSlice"
import chatReducer, { chatApi } from "./chatSlice"
import followersReducer from "./followersSlice"
import { followApi } from "./followSlice"
import { ignoredUsersApi } from "./ignoredUsersSlice"
import messagingReducer, { messagingApi } from "./messagingSlice"
import purchasePageReducer, {
    purchasePageApi,
} from "./purchasePage/purchasePageSlice"
import roomReducer from "./roomSlice"
import userTypingReducer from "./typingIndicatorSlice"
import noteReducer, { notesApi } from "./userList/notesSlice"
import userReducer from "./userSlice"

const rootReducer = combineReducers({
    [notesApi.reducerPath]: notesApi.reducer,
    [purchasePageApi.reducerPath]: purchasePageApi.reducer,
    [messagingApi.reducerPath]: messagingApi.reducer,
    [followApi.reducerPath]: followApi.reducer,
    [ignoredUsersApi.reducerPath]: ignoredUsersApi.reducer,
    [accountsApi.reducerPath]: accountsApi.reducer,
    [chatApi.reducerPath]: chatApi.reducer,
    purchasePage: purchasePageReducer,
    user: userReducer,
    notes: noteReducer,
    messaging: messagingReducer,
    userTyping: userTypingReducer,
    room: roomReducer,
    broadcast: broadcastReducer,
    chat: chatReducer,
    followers: followersReducer,
    appPanel: appPanelReducer,
})
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const setupStore = (preloadedState?: RootState) =>
    configureStore({
        reducer: rootReducer,
        preloadedState: preloadedState,
        middleware: (getDefaultMiddleware) =>
            getDefaultMiddleware().concat([
                notesApi.middleware,
                purchasePageApi.middleware,
                messagingApi.middleware,
                followApi.middleware,
                ignoredUsersApi.middleware,
                accountsApi.middleware,
                chatApi.middleware,
            ]),
    })
export const store = setupStore(
    (window as any).$reactAppContext
        ? ({
              user: {
                  languageCode: (window as any).$reactAppContext.language_code,
                  loggedInUser: (window as any).$reactAppContext.logged_in_user,
              },
          } as RootState)
        : undefined,
)

setupListeners(store.dispatch)

export type RootState = ReturnType<typeof rootReducer>
export type AppStore = ReturnType<typeof setupStore>
export type AppDispatch = AppStore["dispatch"]
